import { FC } from "react";
import Layout from "../../layout/Layout";

const GeneralPoliciesPage: FC<{}> = () => {
    return (
        <Layout>
            <div
                className="w-100 px-3 p_spaced"
                style={{ backgroundImage: "url(/assets/pages/contact/bg_contact.jpg)", backgroundSize: "contain" }}
            >
                <div className="container">
                    <div className="bg-white p-5">
                        <div className="side side_top mb-3">
                            <h2>Política de Privacidad</h2>
                        </div>
                        <p>
                            WCAR S.A.S., sociedad legalmente constituida de acuerdo con las leyes de la República de
                            Colombia, identificada con el N.I.T. 901566049-8, ubicada en Bogotá, (en adelante “WCAR”)
                            dispone para los interesados las siguientes POLÍTICAS DE TRATAMIENTO DE LOS DATOS PERSONALES
                            las cuales se encuentran dirigidas a todos nuestros Clientes Finales, Empleados, Ex
                            empleados, Proveedores, Contratistas, Accionistas y demás titulares y legitimados de los
                            datos personales registrados en cada una de nuestras bases de datos (en adelante “Los
                            Titulares”). El presente documento describe los derechos y obligaciones de Los Titulares
                            respecto de los cuales WCAR ejerce alguna de las formas de tratamiento, de acuerdo con lo
                            establecido en la ley 1581 de 2012 y el Decreto 1377 de 2013.
                        </p>
                        <p>
                            De conformidad con las previsiones de la Ley Estatutaria 1581 de 2012 el cual establece el
                            Régimen General de Habeas Data y Tratamiento de Datos Personales, WCAR S.A.S. sociedad
                            comercial, identificada con NIT 901566049 - 8 (en adelante “WCAR”), actuando como entidad
                            que almacena y recolecta datos de carácter personal, requiere obtener para el tratamiento de
                            sus datos personales la presente autorización, motivo por el cual dispone la presente
                            Política de Tratamiento de Datos Personales, la cual está dirigida a todos nuestros Clientes
                            Finales, Usuarios, Empleados, Ex empleados, Proveedores, Contratistas, Accionistas y demás
                            titulares de los datos personales registrados en cada una de nuestras bases de datos (en
                            adelante “Los Titulares”), previo haber informado lo siguiente:
                        </p>

                        <ul>
                            <li>
                                WCAR es una empresa dedicada a la comercialización de vehículos usados para lo cual
                                cuenta con el conocimiento del mercado y una infraestructura que le permite ofrecerlos
                                al público, facilitando así la posibilidad de encontrar compradores interesados en
                                adquirirlos, y una vez ubicado el comprador, facilitar el proceso de venta, traspaso y
                                entrega del vehículo.
                            </li>
                            <li>
                                WCAR es propietario de la Plataforma Tecnológica que permite vincular a personas
                                interesadas en vender un vehículo con aquellas interesadas en adquirirlo.
                                Adicionalmente, permite prestar servicios de trámites de traspaso, intermediación en la
                                consecución de créditos, entre otros.
                            </li>
                            <li>
                                Mediante el ingreso de un usuario a través de la Plataforma Tecnológica, quien hace uso
                                de la misma acepta la Política de Tratamiento de Datos Personales de WCAR y todos los
                                Términos y Condiciones aquí contenidos. Asimismo, se entiende que acepta todas las demás
                                reglas de operación, políticas y procedimientos que puedan ser publicados por WCAR.
                            </li>
                            <li>
                                WCAR actuará como Responsable del Tratamiento de Datos Personales, toda vez que al tener
                                el control tecnológico de sus plataformas tecnológicas, tendrá acceso directo a los
                                datos que los usuarios ingresen e interactúen.
                            </li>
                            <li>
                                Cuando la información que sea tratada por WCAR, sea de carácter sensible o sea de
                                menores de edad, el otorgamiento de la autorización para el tratamiento es de carácter
                                facultativo.
                            </li>
                            <li>
                                El Titular (como adelante se define) manifiesta de manera expresa que WCAR se exime de
                                responsabilidad por el incumplimiento del Titular de sus obligaciones relacionadas con
                                el manejo de datos personales. Adicionalmente, el Titular se hace responsable de la
                                información de terceros que comparta en la Plataforma Tecnológica sin su autorización.
                            </li>
                        </ul>

                        <p>
                            La información personal recolectada y tratada por WCAR es y será utilizada para el
                            desarrollo de las actividades comerciales de la compañía, su matriz, filiales, subsidiarias,
                            controladas y similares, y a su vez, el funcionamiento, optimización y creación de nuevas
                            funcionalidades de la Plataforma Tecnológica. Esta finalidad incluye, pero no se limita a:
                            fines estadisticos, comerciales, informativos, de seguimiento al producto, de mercadeo, de
                            notificación y contacto, campañas de seguridad y/o de satisfacción, marketing, verificación
                            en centrales de riesgo, aspectos contables y de nómina, y demás aplicables a cada uno de los
                            Titulares.{" "}
                        </p>
                        <p>
                            Especialmente la información recopilada será incorporada dentro de las bases de datos de
                            WCAR con las siguientes finalidades: {" "}
                        </p>

                        <ul>
                            <li>Realizar sus actividades comerciales y ejecución de su objeto social.</li>
                            <li>
                                Entablar un contacto directo con los clientes, compradores y vendedores de los vehiculos
                                ofrecidos en la Plataforma Tecnológica.
                            </li>
                            <li>
                                Gestionar el proceso de reserva de los vehiculos por parte de los compradores y/o
                                clientes.
                            </li>
                            <li>
                                Remitir a los compradores la confirmación de la disponibilidad del vehiculo según la
                                reserva efectuada.
                            </li>
                            <li>
                                Cumplir con requerimientos internos de la Plataforma Tecnológica, incluyendo, pero sin
                                limitarse, a la creación de usuarios y/o cuentas, asignación de contraseñas, datos de
                                reserva, entre otros.
                            </li>
                            <li>
                                Optimizar sus tecnologías y desarrollar nuevas funcionalidades a partir de los datos que
                                recolecte.
                            </li>
                            <li>
                                Ejecución de los contratos que WCAR celebre en curso del desarrollo de sus actividades y
                                la prestación de los servicios contratados.
                            </li>
                            <li>Remitir encuestas de satisfacción acerca del servicio prestado.</li>
                            <li>Enviar información promocional y publicitaria por cualquier medio online y offline.</li>
                            <li>
                                Crear una base de datos de contacto de usuarios con el fin de llevar un registro interno
                                de sus datos personales.
                            </li>
                            <li>Mitigar el riesgo de suplantación de identidad de los usuarios.</li>
                            <li>
                                Atender peticiones, quejas, reclamos, inquietudes, y solicitudes elevadas por el
                                Titular.
                            </li>
                            <li>
                                Compartir los datos personales con terceros, si fuera necesario, para lograr el
                                cumplimiento del objeto social de WCAR.
                            </li>
                            <li>
                                Las demás finalidades que se encuentran establecidas de manera específica en la presente
                                Política.
                            </li>
                        </ul>

                        <p>
                            El Titular de la información cuenta con los derechos que le ha conferido la Constitución y
                            la Ley entre otros, los de conocer, actualizar, rectificar y solicitar la supresión de los
                            datos personales suministrados, conocer los usos empleados sobre los datos, revocar su
                            autorización conferida, acceder de forma gratuita a sus datos personales y presentar ante la
                            Superintendencia de Industria y Comercio quejas por infracciones a lo dispuesto en la
                            presente ley y las demás normas que la modifiquen, adicionen o complementen. De igual
                            manera, el Titular podrá solicitar a WCAR, en cualquier momento, que no se le envíe
                            información promocional o publicitaria, o que se le envíe sólo cierta información que sea de
                            su interés.
                        </p>

                        <p>
                            En virtud de lo anterior, el Titular de manera voluntaria, previa, expresa, informada e
                            inequívoca autoriza a WCAR para tratar sus datos personales de acuerdo con la Política de
                            Tratamiento de Datos personales de aquí relacionada y para los fines relacionados con su
                            objeto social.
                        </p>

                        <p>
                            El Titular se reserva el derecho a suministrar a WCAR, de manera facultativa, información
                            sobre datos sensibles, así mismo está bajo su total discreción el proporcionar cualquier
                            dato personal sensible o no sensible que sea requerido por WCAR. WCAR no solicitará bajo
                            ninguna circunstancia el suministro de datos sensibles a los Titulares.
                        </p>

                        <p>
                            Mediante esta autorización, WCAR queda autorizada para recolectar, compilar almacenar,
                            circular, compartir con terceros si es necesario, transferir y transmitir en el territorio
                            nacional o internacionalmente, usar, comunicar, procesar, organizar, analizar, estudiar,
                            clasificar, suprimir y disponer de los datos personales del Titular de acuerdo con las
                            finalidades previstas en esta autorización y la presente Política. En cualquier caso, el
                            (los) Encargado (s) del Tratamiento, si lo hubiere se someterán a las presentes Políticas de
                            Tratamiento de Datos personales y a los manuales internos de procedimiento para el
                            Tratamiento de la información.
                        </p>

                        <p>
                            Sin perjuicio de lo anterior, los servicios o productos que se ofrezcan en la Plataforma
                            Tecnológica que contengan términos y condiciones adicionales, implicará la aceptación
                            adicional de éstos. En caso que el usuario no los acepte, deberá abstenerse de utilizar en
                            cualquier forma la Plataforma Tecnológica.
                        </p>

                        <p>
                            Cualquier consulta, petición, solicitud, o queja por parte del Titular respecto del
                            tratamiento de sus datos personales así como rectificaciones, actualizaciones, o supresión
                            de sus Datos Personales del Tratamiento por parte de WCAR, podrá ser tramitada a través del
                            departamento de Servicio al Cliente de WCAR, al correo electrónico contacto@wcar.co o
                            directamente en la Calle 98 a 69 b 34 en la ciudad de Bogotá, Colombia.
                        </p>
                        <div className="side side_top mb-3">
                            <h2>AVISO DE PRIVACIDAD </h2>
                        </div>
                        <p>
                            La presente Política de Tratamiento de Datos Personales de WCAR (en adelante la "Política"),
                            establece los mecanismos, garantías e instrumentos que detentan los titulares de la
                            información que recolectamos y tratamos en calidad de Responsables del Tratamiento a la luz
                            de la Ley 1581 de 2012, Decreto 1377 de 2013 y demás normas aplicables en materia de
                            protección de datos personales.
                        </p>
                        <p>
                            Debido a la actividad comercial que desarrolla WCAR recoge, y en algunos casos, comunica a
                            terceras personas, información sobre los compradores, vendedores, usuarios, trabajadores,
                            proveedores, aliados estratégicos, entre otros. En ese orden de ideas, la siguiente Política
                            tiene como propósito brindarle a estos un panorama claro respecto de los datos personales
                            que WCAR recauda, el tratamiento que se da a los mismos y los procedimientos que los
                            Titulares tienen a su alcance para poder hacer efectivos los derechos derivados de aquellos.
                        </p>
                        <p>
                            Los titulares deben leer previa y detalladamente la información contenida en esta Política,
                            ya que la misma pretende brindarles un panorama claro respecto a los datos personales que
                            WCAR recauda, el tratamiento que se le da a los mismos y los procedimientos que tienen a su
                            alcance para poder hacer efectivos sus derechos.
                        </p>
                        <p>
                            De no estar de acuerdo con la presente Política, los Titulares deberán abstenerse de
                            proporcionar sus datos a WCAR.
                        </p>

                        <div className="side side_top mb-3">
                            <h2>POLITICA DE TRAMITE DE DATOS PERSONALES DE WCAR S.A.S.</h2>
                        </div>

                        <p>
                            WCAR S.A.S. sociedad identificada con NIT No. 901566049 - 8 con domicilio principal en la
                            ciudad de Bogotá D.C, con correo electrónico contacto@wcar.co, por medio de la presente se
                            permite establecer y hacer públicos los principios y parámetros mediante los cuales
                            adelantará el tratamiento de los datos personales que recolecte en desarrollo de su objeto
                            social, en las calidades tanto de responsable, como de encargado del manejo de la
                            información.
                        </p>
                        <p>
                            WCAR en ejecución de su actividad empresarial, recauda datos personales de terceros, por tal
                            motivo, para garantizar los derechos constitucionales y legales de las personas que han
                            suministrado sus datos y/o los suministrarán en el futuro, WCAR adopta las siguientes
                            políticas de tratamiento de datos personales, en los términos de la ley 1581 de 2012, el
                            Decreto 1377 de 2013, y demás normas que los modifiquen.
                        </p>
                        <p>
                            Mediante el acceso o la utilización de la Plataforma Tecnológica (como adelante se define),
                            el Titular acepta la Política de Tratamiento de Datos Personales de WCAR y todos los
                            Términos y Condiciones aquí contenidos.
                        </p>
                        <p>
                            Asimismo, se entiende que acepta todas las demás reglas de operación, políticas y
                            procedimientos que puedan ser publicados por WCAR en la página de web
                            https://wcar.co/politica-de-privacidad.
                        </p>
                        <div className="side side_top mb-3">
                            <h2>CONTEXTUALIZACIÓN.</h2>
                        </div>
                        <p>
                            WCAR ha desarrollado una Plataforma Tecnológica que permite (i) vincular a personas
                            interesadas en vender un vehículo con aquellas interesadas en adquirirlo; (ii) presta
                            servicios de trámites de traspaso de vehículos; (iii) intermediación en la consecución de
                            créditos a las personas interesadas en adquirir los vehículos ofertados en la Plataforma
                            Tecnológica.
                        </p>
                        <p>
                            Es importante aclarar que la gestión de WCAR podrá ser: (i) en calidad de corredor actuando
                            en nombre y representación de un tercero vendedor; y (ii) excepcionalmente podrá ser
                            vendedor cuando adquiera la propiedad del vehículo a ofrecer mediante la Plataforma
                            Tecnológica. En el primer caso, WCAR no garantiza el éxito o resultado de su gestión en el
                            ofrecimiento en venta del vehículo al público, sin embargo, se compromete a prestar sus
                            mejores oficios y esfuerzos en lograr la venta.
                        </p>
                        <p>
                            Así mismo, WCAR recolecta información personal en su página web y aplicación móvil para que
                            los potenciales compradores efectúen la reserva y/o separación del vehiculo (término que más
                            adelante se define) y para que sus usuarios naveguen en la Plataforma Tecnológica y puedan
                            acceder a ciertas funcionalidades allí previstas.
                        </p>
                        <p>
                            De igual manera, para el normal desarrollo de las actividades comerciales y negocios de
                            WCAR, el cumplimiento de sus actividades legales o contractuales, se requiere el Tratamiento
                            de datos e información personal de los trabajadores, proveedores y aliados estratégicos en
                            los términos de la presente Política.
                        </p>
                        <ul>
                            <li>
                                <strong>1) Objetivo:</strong> Por medio de la presente política de tratamiento de datos,
                                WCAR pretende establecer las reglas aplicables al tratamiento de datos personales
                                recolectados, usados y almacenados en desarrollo de su objeto social; en las calidades
                                de responsable y/o encargado del tratamiento de la información según sea el caso.
                            </li>
                            <li>
                                <strong>2) Ámbito de aplicación:</strong>
                                La presente política se aplicará al tratamiento de datos personales efectuado en
                                territorio colombiano, o cuando le sean aplicables las normas sobre protección de datos
                                personales al responsable y/o encargado ubicado fuera del territorio colombiano, en
                                virtud de tratados internacionales, relaciones contractuales, entre otros.
                                <br />
                                Las disposiciones contenidas en esta política se aplicarán a cualquier base de datos
                                personales que se encuentren en custodia de WCAR, bien sea en calidad de responsable y/o
                                encargado del tratamiento.
                                <br />
                                Tratándose de los potenciales Compradores, Vendedores y Usuarios (definidos a
                                continuación), WCAR informa que sus datos son captados por una sociedad domiciliada en
                                Colombia. Por lo tanto, los datos suministrados se someterán a las reglas de esta
                                política de protección de datos y a las normas que para tales efecto ha dispuesto la
                                legislación colombiana.
                            </li>
                            <li>
                                <strong>3) Definiciones:</strong> De conformidad con la legislación vigente sobre la
                                materia, se establecen las siguientes definiciones, las cuales serán aplicadas e
                                implementadas acogiendo los criterios de interpretación que garanticen una aplicación
                                sistemática e integral, y en consonancia con los avances tecnológicos, la neutralidad
                                tecnológica, y los demás principios y postulados que rigen los derechos fundamentales
                                que circundan, orbitan y rodean el derecho de hábeas data y protección de datos
                                personales.
                            </li>
                            <li>
                                <strong>3.1) Autorización y/o Autorizaciones:</strong> Consentimiento previo, expreso e
                                informado del Titular para tratar sus datos personales que no tengan la característica
                                de públicos.
                            </li>
                            <li>
                                <strong>3.2) Aviso de Privacidad:</strong> Comunicación verbal o escrita generada por el
                                Responsable, dirigida al Titular para el Tratamiento de sus Datos Personales, mediante
                                la cual se le informa acerca de la existencia de las Políticas de Tratamiento de
                                información que le serán aplicables, la forma de acceder a las mismas y las finalidades
                                del Tratamiento que se pretende dar a los datos personales.
                            </li>
                            <li>
                                <strong>3.3) Comprador:</strong> Persona natural o jurídica interesada en adquirir el
                                vehículo a través de la Plataforma tecnológica de WCAR, quien efectúa el pago de la
                                reserva y del precio según lo establecido en los términos y condiciones establecidos
                                para tal fin.
                            </li>
                            <li>
                                <strong>3.4) Base de Datos Personales:</strong> Conjunto organizado de datos que es
                                objeto de tratamiento de WCAR. Puede ser automatizada o física de acuerdo con su forma
                                de almacenamiento.
                            </li>
                            <li>
                                <strong>3.5) Dato Personal:</strong> Cualquier información vinculada o que pueda
                                asociarse a una o varias personas naturales determinadas o determinables. Son algunos
                                ejemplos de datos personales los siguientes: nombre, cédula de ciudadanía, dirección,
                                correo electrónico, número telefónico, estado civil, datos de salud, huella dactilar,
                                salario, bienes, estados financieros, etc.
                            </li>
                            <li>
                                <strong>3.6) Dato Personal Sensible:</strong> Información que afecta la intimidad del
                                Titular o cuyo uso indebido puede generar su discriminación, tales como aquellos que
                                revelen el origen racial o étnico, la orientación política, las convicciones religiosas
                                o filosóficas, la pertenencia a sindicatos, organizaciones sociales, de derechos humanos
                                o que promueva intereses de cualquier partido político o que garanticen los derechos y
                                garantías de partidos políticos de oposición así como los datos relativos a la salud, a
                                la vida sexual y los datos biométricos, entre otros, la captura de imagen fija o en
                                movimiento, huellas digitales, fotografías, iris, reconocimiento de voz, facial o de
                                palma de mano, etc.
                            </li>
                            <li>
                                <strong>3.7) Encargado del Tratamiento:</strong> Persona natural o jurídica, pública o
                                privada, que por sí misma o en asocio con otros, realice el Tratamiento de Datos
                                Personales por cuenta del Responsable del Tratamiento. En los eventos en que el
                                Responsable no ejerza como Encargado de la Base de Datos, se identificará expresamente
                                quién será el Encargado.
                            </li>
                            <li>
                                <strong>3.8) Plataforma tecnológica:</strong> Hace referencia al desarrollo tecnológico
                                que despliega WCAR a través de una página web bajo el nombre de dominio https://wcar.co,
                                y una aplicación móvil denominada Wcar.co, que permite vincular a personas interesadas
                                en vender un vehículo con aquellas interesadas en adquirirlo. Adicionalmente, permite
                                prestar servicios de trámites de traspaso, intermediación en la consecución de créditos,
                                entre otros.
                            </li>
                            <li>
                                <strong>3.9) Reclamo:</strong> Solicitud del Titular del dato o de las personas
                                autorizadas por éste o por la Ley para corregir, actualizar o suprimir sus datos
                                personales o para revocar la autorización en los casos establecidos en la Ley.
                            </li>
                            <li>
                                <strong>3.10) Responsable del Tratamiento:</strong> Persona natural o jurídica, pública
                                o privada, que por sí misma o en asocio con otros, decida sobre la Base de Datos y/o el
                                Tratamiento de los datos.
                            </li>
                            <li>
                                <strong>3.11) Reserva:</strong> Se refiere a la separación del vehículo que hace el
                                comprador con la finalidad de que WCAR confirme la disponibilidad para la venta
                                inmediata.
                            </li>
                            <li>
                                <strong>3.12) Términos y Condiciones:</strong> Marco general en el cual se establecen
                                las condiciones para los participantes de actividades promocionales o afines.
                            </li>
                            <li>
                                <strong>3.13) Titular:</strong> Persona natural cuyos Datos Personales sean objeto de
                                Tratamiento.
                            </li>
                            <li>
                                <strong>3.14) Transferencia:</strong> La transferencia de datos tiene lugar cuando el
                                Responsable y/o Encargado del Tratamiento de datos personales, ubicado en Colombia,
                                envía la información o los datos personales a un receptor, que a su vez es Responsable
                                del Tratamiento y se encuentra dentro o fuera del país.
                            </li>
                            <li>
                                <strong>3.15) Transmisión:</strong> Tratamiento de Datos Personales que implica la
                                comunicación de los mismos dentro o fuera del territorio de la República de Colombia
                                cuando tenga por objeto la realización de un Tratamiento por el Encargado por cuenta del
                                Responsable.
                            </li>
                            <li>
                                <strong>3.16) Vendedor:</strong> Persona natural o jurídica que tiene la calidad de
                                propietario de un vehículo y desea venderlo a través de la Plataforma tecnológica de
                                WCAR, en virtud de un contrato de corretaje. Excepcionalmente, podrá ser WCAR si
                                adquiere la propiedad del vehículo ofrecido.
                            </li>
                            <li>
                                <strong>3.17) Usuario:</strong> Persona que realiza el ingreso, registro, inicio de
                                sesión y/o interacción con la Plataforma tecnológica de WCAR. Dentro de esta categoría
                                se encuentran entre otros, los potenciales compradores, vendedores, fuerza de ventas,
                                empleados, colaboradores y/o prestadores de servicios, proveedores, aliados estratégicos
                                y cualquier otra persona que utilice y acceda a cualquiera de las Plataformas
                                Tecnológicas.
                            </li>
                            <li>
                                <strong>4) Responsable del Tratamiento de Datos Personales.</strong>Para el Tratamiento
                                de los Datos Personales, WCAR aplicará los principios que se mencionan a continuación,
                                los cuales constituyen las reglas a seguir en la recolección, manejo, uso, tratamiento,
                                almacenamiento e intercambio, de datos personales:{" "}
                            </li>
                            <li>
                                <strong>5) Principios aplicables al tratamiento de datos personales.</strong>Para el
                                Tratamiento de los Datos Personales, WCAR aplicará los principios que se mencionan a
                                continuación, los cuales constituyen las reglas a seguir en la recolección, manejo, uso,
                                tratamiento, almacenamiento e intercambio, de datos personales:{" "}
                            </li>
                            <li>
                                <strong>5.1) Legalidad:</strong> El Tratamiento de datos personales se realizará
                                conforme a las disposiciones legales aplicables (Ley Estatutaria 1581 de 2012 y sus
                                decretos reglamentarios).
                            </li>
                            <li>
                                <strong>5.2) Finalidad:</strong> Los datos personales recolectados serán utilizados para
                                un propósito específico y explícito el cual debe ser informado al Titular o permitido
                                por la Ley. El Titular será informado de manera clara, suficiente y previa acerca de la
                                finalidad de la información suministrada.
                            </li>
                            <li>
                                <strong>5.3) Libertad:</strong> La recolección de los Datos Personales sólo podrá
                                ejercerse con la autorización, previa, expresa e informada del Titular.
                            </li>
                            <li>
                                <strong>5.4) Veracidad o Calidad:</strong> La información sujeta al Tratamiento de Datos
                                Personales debe ser veraz, completa, exacta, actualizada, comprobable y comprensible.
                            </li>
                            <li>
                                <strong>5.5) Transparencia:</strong> En el Tratamiento de Datos Personales se garantiza
                                el derecho del Titular a obtener en cualquier momento y sin restricciones, información
                                acerca de la existencia de datos que le concierne.
                            </li>
                            <li>
                                <strong>5.6) Acceso y circulación restringida:</strong> El Tratamiento de datos
                                personales sólo podrá realizarse por las personas autorizadas por el Titular y/o por las
                                personas previstas en la Ley.
                            </li>
                            <li>
                                <strong>5.7) Seguridad:</strong> Los Datos Personales sujetos a Tratamiento se manejarán
                                adoptando todas las medidas de seguridad que sean necesarias para evitar su pérdida,
                                adulteración, consulta, uso o acceso no autorizado o fraudulento.
                            </li>
                            <li>
                                <strong>5.8) Confidencialidad:</strong> Todos los funcionarios que trabajen en WCAR y
                                los encargados de la información están obligados a guardar reserva sobre la información
                                personal a la que tengan acceso con ocasión de su trabajo.
                            </li>
                            <li>
                                <strong>6) Tratamiento al cual serán sometidos los datos\: </strong>El tratamiento que
                                realizará WCAR actuando como Responsable y/o Encargado será el de recolectar, compilar,
                                almacenar, circular, compartir con terceros, transferir y transmitir en el territorio
                                nacional o internacionalmente, usar, comunicar, procesar, organizar, analizar, estudiar,
                                clasificar, suprimir y disponer de los datos personales, atendiendo de forma estricta
                                los lineamientos establecidos por la ley.{" "}
                                <p>
                                    Los datos y autorizaciones de Tratamiento se recolectarán de la siguiente manera:{" "}
                                </p>
                                <p>
                                    <strong>Medios físicos: </strong>
                                    Ello cuando se realiza el suministro de la información por parte de los Titulares,
                                    de manera telefónica, por escrito, o verbalmente.
                                </p>
                                <p>
                                    <strong>Medios electrónicos:</strong>
                                    Se obtendrán los datos del Titular por medios electrónicos en los siguientes casos:
                                </p>
                            </li>
                            <li>
                                <strong>6.1)</strong> Cuando el Titular ingrese a la Plataforma Tecnológica (incluyendo
                                la página web y/o la aplicación móvil), y a través de la misma le sean requeridos sus
                                datos para acceder a ciertas funcionalidades.
                            </li>
                            <li>
                                <strong>6.2)</strong> Cuando se obtengan los datos del Titular a través de correo
                                electrónico, aplicaciones móviles de comunicación, mensajes de texto (SMS) o
                                notificaciones PUSH (mensajes instantáneos que recibirá en el dispositivo en el que
                                ingrese a la Plataforma Tecnológica).
                                <p>
                                    Especificaciones sobre el almacenamiento: Los datos recaudados y las autorizaciones
                                    serán almacenados en las Bases de datos de WCAR y/o del Encargado, y permanecerán
                                    bajo su custodia en condiciones de idoneidad, confidencialidad y seguridad
                                    generalmente admitidas. Sólo el personal autorizado podrá acceder a estas Bases de
                                    Datos. Se observarán los protocolos de acceso y seguridad que se consideran estándar
                                    en estas actividades para evitar la vulneración o manipulación de la información
                                    recopilada.
                                </p>
                                <p>
                                    No obstante, lo anterior, WCAR podrá operar las bases de datos mediante un Encargado
                                    del Tratamiento de datos, en cuyo caso, hará saber a los titulares de la información
                                    que estas políticas se extenderán y, por ello, serán aplicables a tal Encargado, de
                                    forma que el Titular pueda ejercer los derechos que le confiere la ley, tanto frente
                                    a WCAR como frente al Encargado del Tratamiento designado por ésta.
                                </p>
                                <p>
                                    De igual manera, todos estos tratamientos pueden ocurrir en sistemas de información
                                    y redes cuyos servidores pueden estar dentro o fuera del territorio nacional. En ese
                                    orden, los datos recogidos pueden ser almacenados en los servidores de WCAR, o en
                                    servidores de empresas que prestan servicios para el almacenamiento de información,
                                    los cuales pueden requerir una Transferencia internacional y/o tratamiento de estos
                                    datos fuera del país de residencia del Titular.
                                </p>
                                <p>La información recopilada se usará en la forma descrita en el siguiente punto. </p>
                            </li>
                            <li>
                                <strong>
                                    7) Finalidades generales de la información personal recopilada en las bases de
                                    datos:
                                </strong>{" "}
                            </li>
                            <li>
                                La información personal que ha recopilado WCAR y/o el Encargado desde el inicio de sus
                                operaciones y la que recopile en adelante, se usará para los siguientes fines:{" "}
                            </li>
                            <li>
                                Para la prestación de los servicios de WCAR a través de su Plataforma Tecnológica, así
                                como la optimización tanto de sus servicios como de la Plataforma.
                            </li>
                            <li>
                                Atender consultas, peticiones, quejas y reclamos presentados por los Titulares y
                                organismos de control, además de transmitir los Datos Personales a las autoridades
                                correspondientes, de acuerdo con las disposiciones legales aplicables.
                            </li>
                            <li>
                                Cumplir con los requerimientos judiciales o administrativos y atender mandatos
                                judiciales o legales.
                            </li>
                            <li>
                                Transferir la información recolectada a distintas áreas de WCAR y a sus vinculadas,
                                tanto a nivel nacional como internacional, cuando sea necesario para el desarrollo de
                                sus operaciones.
                            </li>
                            <li>
                                Registrar los datos personales en los sistemas de información de WCAR, así como en sus
                                bases de datos comerciales y operativas.
                            </li>
                            <li>
                                Facilitar la participación de los Titulares en actividades de mercadeo y promocionales,
                                como concursos, rifas y sorteos organizados por WCAR.
                            </li>
                            <li>
                                Realizar cualquier otra actividad de naturaleza similar a las mencionadas anteriormente
                                que sea necesaria para el cumplimiento del objeto social de WCAR.
                            </li>
                            <li>
                                {" "}
                                Las finalidades aquí previstas son enunciadas, sin perjuicio de que el Usuario o persona
                                que utiliza la Plataforma deba adicionalmente aceptar los términos y condiciones y las
                                Políticas de Privacidad de cada una de las aplicaciones móviles y página web
                                desarrolladas por WCAR.{" "}
                            </li>
                            <li>
                                <strong>
                                    7.1) Finalidades del Tratamiento de Datos Personales para Compradores, Vendedores,
                                    Usuarios:
                                </strong>
                                <strong>WCAR</strong> cuenta con una página web y aplicación móvil mediante la cual
                                ofrece sus servicios y entabla contacto con sus Compradores, Vendedores y/o potenciales
                                clientes.
                            </li>
                            <li>Crear y administrar la cuenta del usuario en la plataforma de WCAR.</li>
                            <li>Comercialización de vehiculos a través de la Plataforma Tecnológica.</li>
                            <li>
                                Cargue a la Plataforma Tecnológica, de las fotografías, imágenes, información y
                                características de vehículos aportadas por el vendedor;
                            </li>
                            <li>
                                Gestionar las reservas de potenciales Compradores, y confirmar la disponibilidad del
                                vehículo para venta inmediata.
                            </li>
                            <li>
                                Crear canales de contacto entre WCAR y los Compradores y/o Vendedores potenciales, así
                                como la recolección de Cookies (pequeños arvhicos de texto que se colocan por parte de
                                un servidor web, en el disco duro de quien navegue en una página web o aplicación) para
                                identificar como el Usuario utiliza los servicios de WCAR, si ha ingresado al sistema,
                                cuando y cómo ingresa, forma de interacción, así como personalizar y mejorar la
                                experiencia del Usuario.
                            </li>
                            <li>
                                Mantener un registro histórico de la información para satisfacer al usuario y llevar a
                                cabo análisis sobre intereses y necesidades con el fin de brindar un mejor servicio.
                            </li>
                            <li>
                                Gestionar las solicitudes, quejas y reclamos de los usuarios y direccionarlos a las
                                áreas responsables de emitir respuestas correspondientes.
                            </li>
                            <li>
                                Generar y remitir información de interés respecto publicidad, actividades promocionales,
                                concursos, y sorteos (email marketing).
                            </li>
                            <li>Elaboración de encuestas de satisfacción.</li>
                            <li>
                                Realizar cualquier otra actividad de naturaleza similar a las mencionadas anteriormente
                                que sea necesaria para el cumplimiento del objeto social de WCAR.
                            </li>
                            <li>
                                <strong>
                                    7.2) Finalidades del Tratamiento de Datos Personales para empleados, colaboradores,
                                    aliados estratégicos:
                                </strong>
                            </li>
                            <li>
                                Administrar y operar, ya sea directamente o por terceros, los procesos de selección y
                                vinculación de personal. Esto implica la evaluación y calificación de los participantes,
                                verificación de referencias laborales y personales.
                            </li>
                            <li>
                                Desarrollar actividades propias de la gestión de recursos humanos dentro de la compañía,
                                como el manejo de la nómina, afiliaciones a entidades del sistema general de seguridad
                                social, actividades de bienestar y salud ocupacional, y ejercicio de la potestad
                                sancionatoria del empleador, entre otras.
                            </li>
                            <li>
                                Realizar los pagos necesarios derivados de la ejecución del contrato de trabajo y/o su
                                terminación, así como las demás prestaciones sociales en conformidad con la ley
                                aplicable y las políticas de protección de datos personales.
                            </li>
                            <li>
                                Notificar a contactos autorizados en caso de emergencias durante el horario de trabajo o
                                en situaciones relacionadas con el desarrollo de las actividades laborales.
                            </li>
                            <li>
                                Coordinar el desarrollo profesional de los empleados y facilitar el acceso de estos a
                                los recursos informáticos del empleador, brindando soporte para su utilización.
                            </li>
                            <li>
                                Tramitar la elaboración de certificaciones relacionadas con la condición de empleado,
                                como certificados de ingresos y retenciones, constancias laborales, etc.
                            </li>
                            <li>Planificar actividades empresariales para el buen funcionamiento de WCAR.</li>
                            <li>
                                Realizar el envío de ofertas de trabajo para la captación de talento adecuado en el
                                momento que se requiera.
                            </li>
                            <li>
                                Respecto a candidatos que entregaron su información al momento de participar en procesos
                                de selección, ocasionalmente esta información será conservada con el fin de efectuar un
                                nuevo contacto en caso abrirse una nueva vacante.
                            </li>
                            <li>
                                Respecto a ex empleados, se conservará la información en caso de ser requerida por
                                alguna autoridad judicial o administrativa.
                            </li>
                            <li>
                                Manejo de información contable y laboral para el cumplimiento de requerimientos
                                contractuales y legales.
                            </li>
                            <li>
                                Creación de canales de contacto entre WCAR, el empleado y sus familiares en caso de ser
                                requerido.
                            </li>
                            <li>
                                Consulta y custodia del historial académico, disciplinario y laboral del empleado con el
                                fin de llevar un registro histórico de los trabajadores que ingresan a la empresa, lo
                                cual a futuro puede ser utilizado para entregar referencias en caso de ser requeridas.
                            </li>
                            <li>
                                Asignación de usuarios y cuentas de correo corporativas, lo cual trae consigo la
                                generación y envío de correspondencia en desarrollo del contrato suscrito entre el
                                trabajador y WCAR.
                            </li>
                            <li>
                                <strong>7.3) Finalidades del Tratamiento de Datos Personales para Proveedores.</strong>
                            </li>
                            <li>Los datos compilados en esta base de datos serán utilizados para: </li>
                            <li>
                                Recopilar información general y de contacto de todos los proveedores que han prestado,
                                prestan y pueden llegar a prestar servicios a favor de WCAR.
                            </li>
                            <li>Establecer un canal de contacto entre los proveedores y WCAR.</li>
                            <li>
                                Preparación y remisión de correspondencia por parte de WCAR respecto a actividades
                                internas, promocionales y sorteos, en los que puedan llegar a participar los titulares.
                            </li>
                            <li>
                                Generación y envío de correspondencia en los casos que WCAR decida impulsar campañas
                                para dar a conocer sus productos, servicios y otros.
                            </li>
                            <li>
                                Seguimiento a la ejecución de los acuerdos, contratos, u órdenes de compra generados en
                                virtud de la relación comercial entre WCAR y el proveedor.
                            </li>
                            <li>Registro contable y seguimiento interno respecto pagos a proveedores.</li>
                            <li>Generar órdenes de compra.</li>
                            <li>
                                Cumplimiento de obligaciones administrativas, contractuales, contables y/o tributarias.
                            </li>
                            <li>
                                Contacto para cotizaciones y solicitud de nuevos servicios y productos requeridos por
                                WCAR con el fin de desarrollar en debida forma su objeto social.
                            </li>
                            <li>Verificar referencias comerciales.</li>
                            <li>
                                <strong>8) Derechos que le asisten al titular de la información.</strong>
                            </li>
                            <li>
                                De acuerdo con las normas constitucionales y legales, el Titular de la información
                                recopilada en nuestras Bases de datos cuenta con las siguientes prerrogativas y
                                derechos, los cuales puede invocar o ejercer frente a WCAR, o frente al Encargado del
                                Tratamiento de Datos personales que obre por cuenta de WCAR como Responsable del
                                Tratamiento:{" "}
                            </li>
                            <li>
                                Acceder de manera gratuita a sus Datos personales, así como conocerlos, actualizarlos,
                                rectificarlos, corregirlos y suprimirlos, siguiendo los procedimientos establecidos más
                                adelante.
                            </li>
                            <li>
                                Solicitar y obtener prueba de la autorización concedida para el tratamiento de los Datos
                                personales, excepto en el caso en que ella se presuma por haberse usado mecanismos
                                alternos de comunicación, como lo prevé el artículo 10 del Decreto 1377 de 2013.
                            </li>
                            <li>Obtener información sobre el uso que se ha dado a su información personal.</li>
                            <li>
                                Acudir ante las autoridades, especialmente ante la Superintendencia Delegada para la
                                Protección de Datos Personales de la Superintendencia de Industria y Comercio, con el
                                fin de solicitar y exigir el amparo de los derechos que le confieren las Leyes.
                            </li>
                            <li>
                                Revocar, en cualquier momento, la autorización para el Tratamiento de sus Datos
                                personales, modificarla o condicionarla. Así mismo, solicitar la supresión del dato, su
                                modificación o aclaración, salvo que sea necesaria la información por razones legales o
                                contractuales.
                            </li>
                            <li>
                                <strong>
                                    9) Deberes de la compañía como responsable del Tratamiento de Datos Personales:
                                </strong>
                                WCAR tiene presente que los Datos Personales son de propiedad de las personas a las que
                                se refiere y solamente ellas pueden decidir sobre los mismos. En ese sentido, WCAR hará
                                uso de los Datos Personales recolectados únicamente para las finalidades para las que se
                                encuentra debidamente facultada y respetando, en todo caso, la normatividad vigente
                                sobre la Protección de Datos Personales. WCAR atenderá los deberes previstos para los
                                Responsables del Tratamiento, contenidos en el artículo 17 de la Ley 1581 de 2012 y las
                                demás normas que la reglamenten, modifiquen o sustituyan.{" "}
                            </li>

                            <li>
                                <strong>10) Autorizacion:</strong>
                                <strong>WCAR</strong> solicitará autorización previa, expresa e informada a los
                                Titulares de los Datos Personales sobre los que requiera realizar el Tratamiento. Esta
                                manifestación de voluntad del Titular puede darse a través de diferentes mecanismos
                                puestos a disposición, tales como:{" "}
                            </li>
                            <li>
                                <strong>10.1)</strong> Por escrito, diligenciando un formato de autorización para el
                                Tratamiento de Datos Personales.
                            </li>
                            <li>
                                <strong>10.2)</strong> De forma oral, a través de una conversación telefónica o en
                                videoconferencia.
                            </li>
                            <li>
                                <strong>10.3)</strong> Mediante conductas inequívocas que permitan concluir que otorgó
                                su autorización, a través de su aceptación a los Términos y Condiciones de una actividad
                                dentro de los cuales se requiera la autorización de los participantes para el
                                Tratamiento de sus Datos Personales o cuando acepte la Política de Tratamiento de datos
                                mediante la página Web de WCAR.
                            </li>
                            <li>
                                <strong>10.4)</strong> Mediante medios electrónicos cuando sea posible guardar
                                constancia de la Autorización para consulta posterior. Se obtendrá la Autorización por
                                medios electrónicos en los siguientes casos: (i) Cuando el Titular ingrese a la página
                                web de la compañía y a través de la misma le sea requerida su Autorización para acceder
                                a ciertas funcionalidades de la página. (ii) Cuando el Titular realiza un ingreso,
                                registro o inicio de sesión en las Plataformas Tecnológicas desarrolladas por la
                                compañía, específicamente en las aplicaciones móviles, y dentro de las mismas se
                                solicita su Autorización a través de un cuadro de texto que le permita señalar al
                                Titular si acepta o no el Tratamiento de sus Datos Personales. (iii) Cuando se obtenga
                                la Autorización del titular a través de correo electrónico, aplicaciones móviles de
                                comunicación como (Whatsapp, Messenger, Telegram, entre otras) o mensajes de texto
                                (SMS).
                            </li>
                            <li>
                                <strong>11) Disposiciones especiales para el tratamiento de datos personales:</strong>
                            </li>
                            <li>
                                <strong>Tratamiento de Datos Personales de Naturaleza Sensible:</strong> El Tratamiento
                                de los Datos Personales de naturaleza sensible está prohibido por la ley, salvo que se
                                cuente con autorización expresa, previa e informada del Titular, entre otras excepciones
                                consagradas en el Artículo 6º de la Ley 1581 de 2012. En este caso, además de cumplir
                                con los requisitos establecidos para la autorización, WCAR le informará al Titular:{" "}
                            </li>
                            <li>
                                <strong>
                                    11.1) Que por tratarse de datos sensibles no está obligado a autorizar su
                                    Tratamiento. 
                                </strong>
                            </li>
                            <li>
                                <strong>
                                    11.2) Cuáles de los datos que serán objeto de Tratamiento son sensibles y la
                                    finalidad del Tratamiento.
                                </strong>
                            </li>
                            <li>
                                Adicionalmente, WCAR tratará los datos sensibles recolectados bajo estándares de
                                seguridad y confidencialidad correspondientes a su naturaleza.
                            </li>
                            <li>
                                Para este fin, WCAR ha implementado medidas administrativas, técnicas y jurídicas, en
                                aras de buscar la protección, seguridad y confidencialidad de los datos personales a los
                                que se tiene acceso.
                            </li>
                            <li>
                                <strong>Tratamiento de Datos Personales de Niños, Niñas y Adolescentes:</strong>
                            </li>
                            <li>
                                Según lo dispuesto por el Artículo 7º de la Ley 1581 de 2012 y el artículo 12 del
                                Decreto 1377 de 2013, WCAR sólo realizará el Tratamiento, correspondientes a niños,
                                niñas y adolescentes, siempre y cuando este Tratamiento responda y respete el interés
                                superior de los niños, niñas y adolescentes y asegure el respeto de sus derechos
                                fundamentales.
                            </li>
                            <li>
                                Cumplidos los anteriores requisitos, WCAR deberá obtener la Autorización del
                                representante legal del niño, niña o adolescente, previo ejercicio del menor de su
                                derecho a ser escuchado, opinión que será valorada teniendo en cuenta la madurez,
                                autonomía y capacidad para entender el asunto.
                            </li>

                            <li>
                                <strong>
                                    12. Procedimientos para que los titulares de la información puedan ejercer sus
                                    derechos:
                                </strong>
                            </li>
                            <li>
                                Con el fin salvaguardar los derechos de los Titulares de la información que reposa en
                                nuestras Bases de datos, y la que se recopile en adelante directamente, WCAR establece
                                los siguientes procedimientos:
                            </li>
                            <li>
                                <strong>12.1)</strong> El Titular de la información (entendiéndose por Titular la
                                persona natural que suministró la información, sus causahabientes y/o apoderados) podrá
                                solicitar en cualquier tiempo, de lunes a viernes en días hábiles de forma electrónica,
                                información (consultas) sobre los datos personales que registran las Bases de datos de
                                WCAR y sobre las autorizaciones concedidas.
                            </li>
                            <li>
                                <strong>12.2)</strong> Así mismo, el Titular podrá elevar peticiones o reclamaciones
                                sobre aclaración, corrección, modificación, rectificación o supresión de datos;
                                revocación o condicionamiento de autorizaciones para el Tratamiento, acompañando los
                                documentos o pruebas que pretenda hacer valer.
                            </li>
                            <li>
                                <strong>12.3)</strong> Para ejercer las prerrogativas a que se refieren los numerales
                                anteriores, el Titular deberá enviar un correo electrónico a contacto@wcar.co
                                identificándose plenamente, a fin de que WCAR pueda corroborar que el peticionario es el
                                Titular de la información.
                            </li>
                            <li>
                                <strong>En la solicitud se debe precisar:</strong>
                            </li>
                            <li>
                                <strong>12.3.1) </strong>Nombre completo y correcto del Titular y/o su apoderado, si es
                                el caso.
                            </li>
                            <li>
                                <strong>12.3.2)</strong> Identificación del Titular y de su representante, en el evento
                                en que actúe a través de apoderado.
                            </li>
                            <li>
                                <strong>12.3.3)</strong> Dato o autorización que se quiere conocer, corregir, modificar,
                                suprimir o revocar, con indicación clara y detallada de la forma en que se pide hacer la
                                corrección o modificación.
                            </li>
                            <li>
                                <strong>12.3.4)</strong> Correo electrónico donde el Titular recibirá respuesta.
                            </li>
                            <li>
                                <strong>12.4)</strong> No obstante, si lo considera, y con el único fin de establecer la
                                identidad plena del peticionario y Titular de la información, WCAR podrá requerir para
                                que se identifique, antes de proceder a responderle.
                            </li>
                            <li>
                                <strong>12.5)</strong> La respuesta a las consultas serán enviadas por WCAR en un
                                término máximo de diez (10) días hábiles contados a partir de la fecha de recibo de la
                                misma. Cuando no fuere posible atender la consulta dentro de dicho término, se informará
                                al interesado, expresando los motivos de la demora y señalando la fecha en que se
                                atenderá su consulta, la cual en ningún caso podrá superar los cinco (5) días hábiles
                                siguientes al vencimiento del primer término.
                            </li>
                            <li>
                                <strong>12.6)</strong> La respuesta a las reclamaciones serán enviadas por WCAR en un
                                término máximo de quince (15) días hábiles contados a partir del día siguiente a la
                                fecha de su recibo. Cuando no fuere posible atender el reclamo dentro de dicho término,
                                se informará al interesado los motivos de la demora y la fecha en que se atenderá su
                                reclamo, la cual en ningún caso podrá superar los ocho (8) días hábiles siguientes al
                                vencimiento del primer término.
                            </li>
                            <li>
                                <strong>13)Transferencia y transmisión de datos personales.</strong>
                            </li>
                            <li>
                                <strong>13.1)</strong> Se trate de contratistas en ejecución de contratos o alianzas
                                para el desarrollo de las actividades de WCAR.
                            </li>
                            <li>
                                <strong>13.2)</strong> Por transferencia a cualquier título de cualquier línea de
                                negocio con la que se relaciona la información.
                            </li>
                            <li>
                                <strong>13.3)</strong> En todo caso, cuando WCAR desee enviar o transmitir datos a uno o
                                varios Encargados ubicados dentro o fuera del territorio de la República de Colombia,
                                establecerá cláusulas contractuales o celebrará un contrato de transmisión de datos
                                personales en el que, entre otros, se pacte lo siguiente:
                            </li>
                            <li>
                                <strong>13.4)</strong> Los alcances y finalidades del tratamiento.
                            </li>
                            <li>
                                <strong>13.5)</strong> Las actividades que el Encargado realizará en nombre de WCAR.
                            </li>
                            <li>
                                <strong>13.6)</strong> Las obligaciones que debe cumplir el Encargado respecto del
                                Titular del dato.
                            </li>
                            <li>
                                <strong>13.7)</strong> El deber del Encargado de tratar los datos de acuerdo con la
                                finalidad autorizada para el mismo y observando los principios establecidos en la Ley
                                colombiana y la presente política.
                            </li>
                            <li>
                                <strong>13.8)</strong> La obligación del Encargado de proteger adecuadamente los datos
                                personales y las bases de datos, así como de guardar confidencialidad respecto del
                                tratamiento de los datos transmitidos.
                            </li>
                            <li>
                                <strong>13.9)</strong> Una descripción de las medidas de seguridad concretas que van a
                                ser adoptadas tanto por WCAR como por el Encargado de los datos en su lugar de destino.
                            </li>
                            <li>
                                <strong>13.10)</strong> WCAR no solicitará la autorización cuando la transferencia
                                internacional de datos se encuentre amparada en alguna de las excepciones previstas en
                                la Ley y sus Decretos Reglamentarios.
                            </li>
                            <li>
                                <strong>14) WCAR como encargada del Tratamiento de Datos Personales.</strong>
                            </li>
                            <li>
                                <strong>14.1)</strong> Garantizar al Titular, en todo tiempo, el pleno y efectivo
                                ejercicio del derecho de hábeas data;
                            </li>
                            <li>
                                <strong>14.2)</strong> Conservar la información bajo las condiciones de seguridad
                                necesarias para impedir su adulteración, pérdida, consulta, uso o acceso no autorizado o
                                fraudulento;
                            </li>
                            <li>
                                <strong>14.3)</strong> Realizar oportunamente la actualización, rectificación o
                                supresión de los datos en los términos de la presente ley;
                            </li>
                            <li>
                                <strong>14.4)</strong> Actualizar la información reportada por los responsables del
                                Tratamiento dentro de los cinco (5) días hábiles contados a partir de su recibo;
                            </li>
                            <li>
                                <strong>14.5)</strong> Tramitar las consultas y los reclamos formulados por los
                                Titulares en los términos señalados en la presente ley;
                            </li>
                            <li>
                                <strong>14.6)</strong> Abstenerse de circular información que esté siendo controvertida
                                por el Titular y cuyo bloqueo haya sido ordenado por la Superintendencia de Industria y
                                Comercio;
                            </li>
                            <li>
                                <strong>14.7)</strong> Permitir el acceso a la información únicamente a las personas que
                                pueden tener acceso a ella;
                            </li>
                            <li>
                                <strong>14.8)</strong> Informar a la Superintendencia de Industria y Comercio cuando se
                                presenten violaciones a los códigos de seguridad y existan riesgos en la administración
                                de la información de los Titulares;
                            </li>
                            <li>
                                <strong>14.9)</strong> Cumplir las instrucciones y requerimientos que imparta la
                                Superintendencia de Industria y Comercio.
                            </li>
                            <li>
                                <strong>14.10)</strong> Respetar los manuales y políticas de tratamiento de datos
                                personales y de seguridad de la información del Responsable del tratamiento de datos
                                personales.
                            </li>
                            <li>
                                <strong>15) Canales de acceso.</strong>
                            </li>
                            <li>
                                En desarrollo de la garantía constitucional de Habeas Data respecto de los derechos de
                                acceso, actualización, rectificación y supresión por parte del Titular de los Datos
                                Personales, sus causahabientes, representantes legales y/o apoderados, WCAR habilitará
                                canales de acceso para los titulares.{" "}
                            </li>
                            <li>
                                <strong>
                                    Todas las comunicaciones, consultas, quejas y/o reclamos deberán ser dirigidas al
                                    área de soporte por cualquiera de los siguientes medios:{" "}
                                </strong>
                            </li>
                            <li>
                                <strong>Atención electrónica: </strong> A través del centro de ayuda disponible tanto en
                                la página web como en la aplicación móvil.{" "}
                            </li>
                            <li>
                                <strong>Atención escrita:</strong> A través de las oficinas administrativas de WCAR,
                                ubicadas en Calle 98 a 69 b 34 en la ciudad de Bogotá, Colombia.{" "}
                            </li>
                            <li>
                                <strong>
                                    16) Fecha de entrada en vigencia de la política de Tratamiento de Datos Personales.
                                </strong>
                            </li>
                            <li>
                                La conservación de los Datos Personales almacenados, utilizados o transmitidos se
                                realizará durante el tiempo necesario para cumplir con las finalidades expuestas en este
                                manual o para que la empresa pueda cumplir con sus deberes legales. No obstante,
                                anualmente se llevará a cabo una revisión de la información para verificar la veracidad
                                del dato y la continuidad de su Tratamiento.
                            </li>
                            <li>
                                La política de Tratamiento de Datos personales a que se refiere este documento estará
                                vigente a partir del 01 de noviembre de 2023, pero podrá ser modificada en cualquier
                                momento por WCAR, en cuyo caso se comunicará lo pertinente a los Titulares.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default GeneralPoliciesPage;
